/**
 * Returns a new array with `item` placed immediately after the last entry
 * whose `type` equals `type`. If none match, `item` is appended.
 */
export function insertAfterLastProductWithType(base, type, item) {
  const lastIdx = base.reduce(
    (acc, product, index) => (product.type === type ? index : acc),
    -1,
  );

  if (lastIdx === -1) {
    return [...base, item];
  }

  return [...base.slice(0, lastIdx + 1), item, ...base.slice(lastIdx + 1)];
}
